let resumeData = {
    "imagebaseurl":"https://rbhatia46.github.io/",
    "name": "Cheah Wen",
    "role": "Computer Science Student in Universiti Teknologi Malaysia",
    "linkedinId":"Your LinkedIn Id",
    "skypeid": "Your skypeid",
    "roleDescription": "",
    "socialLinks":[
        {
          "name":"gmail",
          "url":"mailto:cheahwen1997@gmail.com",
          "className":"fas fa-envelope"
        },      
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/chai-cheah-wen-7859b5162/",
          "className":"fab fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/CodeShareCW",
          "className":"fab fa-github"
        },
        {
          "name":"youtube",
          "url":"https://www.youtube.com/channel/UC5bEF2ytBg0FEuB24Fri6Qw/playlists",
          "className":"fab fa-youtube"
        },
        {
          "name":"medium",
          "url":"https://medium.com/@cheahwen1997",
          "className":"fab fa-medium"
        },

      
      ],
    "aboutme":"A UTM final year undergraduate majoring in Bachelor of Computer Science (Graphics & Multimedia Software). Experience in programming languages (C++, C#, Java, Javascript, PHP, etc), system designs, database, and technical documentation.",
    "address":"Malaysia",
    "website":"https://cheahwen.netlify.app",
    "education":[
      {
        "UniversityName":"Universiti Teknologi Malaysia",
        "specialization":"Bachelor of Computer Science (Graphics & Multimedia Software)",
        "MonthOfPassing":"Present",
        "YearOfPassing":"2021",
        "Achievements": "Achieved Grade: 3.86"
      },
      {
        "UniversityName":"Kluang High School",
        "specialization":"STPM",
        "MonthOfPassing":"Dec",
        "YearOfPassing":"2016",
        "Achievements": "Achieved Grade: 3.84"
      },
      {
        "UniversityName":"SMK Tengku Aris Bendahara Kluang",
        "specialization":"SPM",
        "MonthOfPassing":"Dec",
        "YearOfPassing":"2014",
        "Achievements": "Achieved Grade: 7As"
      }
    ],
    "work":[
      {
        "CompanyName":"Global Genesis",
        "specialization":"Junior Programmer",
        "MonthOfLeaving":"Feb",
        "YearOfLeaving":"2021",
        "Achievements":["Web Portal Enhancement using HTML, CSS, JS, PHP, Jquery, Bootstrap, Datatable, MySQL and so on",
        "Implement mailing system using PHPMailer and bulk upload using PHPSpreadsheet",
        "Data collection, FR .Net view board system large-scale testing",
        "Exploring Atlas 200 DK, experiencing some Linux CLI and Mind Studio model conversion",
        "Developed ALPR app using pre-trained models, use Python library such as OpenCV, Kivy, aiomysql, etc",
        "Bug fixing, code refactoring, and troubleshoot error during internship"]
      }
    ],
    "skillsDescription":"The skill levels are based on the familiarity and development experience from my past projects",
    "skills":[
      {
        "displayname": "Full Stack Web Development (HTML5, CSS, JS, PHP, ReactJS, NodeJS, etc)",
        "skillname":"webdev"
      },
      {
        "displayname": "Game Development (Unity3D, PUN2 For Unity)",
        "skillname":"gamedev"
      },
      {
        "displayname": "SQL Database (MySQL)",
        "skillname":"sqldb"
      },
      {
        "displayname": "NoSQL Database (MongoDB)",
        "skillname":"nosqldb"
      },
      {
        "displayname": "Mobile App Development (Unity3D)",
        "skillname":"mobdev"
      },
      {
        "displayname": "Source Control Tools (Github)",
        "skillname":"git"
      }, 
      {
        "displayname": "PAAS (Netlify, Heroku)",
        "skillname":"paas"
      },
      {
        "displayname": "Machine Learning Framework (Tensorflow, Pytorch)",
        "skillname":"ml"
      },
      {
        "displayname": "3D Modelling (Blender)",
        "skillname":"modelling"
      } 
    ],
    "portfolio":[
      {
        "name":"Attendlytical",
        "description":"Attendance Web App Using Facial Recognition",
        "imgurl":"images/portfolio/FaceIn.png",
        "projectLink": "/portfolio/attendlytical"
      },
      {
        "name":"Hybrid App Of Attendance App",
        "description":"A hybrid app using Flutter",
        "imgurl":"images/portfolio/HybridApp.png",
        "projectLink": "/portfolio/FlutterAttendanceApp"
      },
      {
        "name":"ALPR App",
        "description":"A desktop app for detect license plate and OCR",
        "imgurl":"images/portfolio/ALPR.png",
        "projectLink": "/portfolio/ALPR"
      },
      {
        "name":"Alzheimer Daily Helper",
        "description":"Mobile app for alzheimer patients",  
        "imgurl":"images/portfolio/AZH.png",
        "projectLink": "/portfolio/AlzheimerDailyHelper"
      },
      {
        "name":"Hierarchical Modelling",
        "description":"Simple modelling using OpenGL",
        "imgurl":"images/portfolio/HierarchicalModelling.png",
        "projectLink": "/portfolio/HierarchicalModelling"
      },
      {
        "name":"Mini Paint",
        "description":"Simple app to draw primitives",
        "imgurl":"images/portfolio/MiniPaint.png",
        "projectLink": "/portfolio/MiniPaint"
      },
      {
        "name":"VR Scene Walkthrough",
        "description":"Simple VR mobile app",
        "imgurl":"images/portfolio/VRWalkthrough.png",
        "projectLink": "/portfolio/VRSceneWalkthrough"
      },
      {
        "name":"Whacking Mole Game",
        "description":"Whacking Mole Game using Hologram with Unity3D",
        "imgurl":"images/portfolio/WhackingMole.png",
        "projectLink": "/portfolio/WhackingMole"
      },
      {
        "name":"Unity3D Portal using Leap Motion",
        "description":"A VR game to create portal with natural hand gesture using Leap Motion in Unity3D",
        "imgurl":"images/portfolio/LeapMotionPortal.png",
        "projectLink": "/portfolio/LeapMotionPortal"
      },

      {
        "name":"Feature Tracking for AR Web App",
        "description":"A mini application of AR web app",
        "imgurl":"images/portfolio/ARWebApp.png",
        "projectLink": "/portfolio/ARWebApp"
      },
      {
        "name":"Tower Building Game",
        "description":"Simple game developed using C++",
        "imgurl":"images/portfolio/TB.png",
        "projectLink": "/portfolio/TowerBuilder"
      },
      {
        "name":"Tic Tac Toe",
        "description":"A mini game of Tic Tac Toe using Minimax Algorithm in C++",
        "imgurl":"images/portfolio/TicTaeToe.png",
        "projectLink": "/portfolio/TicTacToe"
      },
      {
        "name":"How Fast You Are",
        "description":"A mini game developed using Unity3D",
        "imgurl":"images/portfolio/HowFastYouAre.png",
        "projectLink": "/portfolio/HowFastYouAre"
      },
      {
        "name":"Working Cells",
        "description":"A multiplayer game developed using Unity3D, Photon 2 & Tenenet gamification",
        "imgurl":"images/portfolio/WorkingCells.png",
        "projectLink": "/portfolio/WorkingCells"
      },
      {
        "name":"3D Street Scene",
        "description":"A walkthrough scene with raining and fog post processing using Unity3D",
        "imgurl":"images/portfolio/UnityRaining.png",
        "projectLink": "/portfolio/3DStreetScene"
      },
      {
        "name":"Rat & Ice Cream",
        "description":"3D modelling using Blender",
        "imgurl":"images/portfolio/Rat & Ice Cream.jpg",
        "projectLink": "/portfolio/RatIceCream"
      },
      {
        "name":"Fruit Classification using CNN",
        "description":"Build a CNN model for fruit classification using Pytorch with Jovian Notebook",
        "imgurl":"images/portfolio/CNN.png",
        "projectLink": "https://jovian.ai/cheahwen1997/assignment-5-fruit-classification"
      },
    ],
  }
  
  export default resumeData